// ============================================================================
// GERMAN TRANSLATIONS - CHAPTER 2: DER EXODUS
// ============================================================================
// Stufen 14-26 (13 Stufen, 39 Fragen)

export const chapter2Translations = {
  name: "Der Exodus",
  description: "Die Befreiung von Gottes Volk... Gott zu kennen verwandelt unser Leben",
  
  spiritualWisdom: {
    principle: "Die Erkenntnis Gottes befreit und verwandelt",
    scripture: "Ihr werdet die Wahrheit erkennen, und die Wahrheit wird euch frei machen (Johannes 8:32)",
    application: "Wie Israel aus Ägypten befreit wurde, so befreit uns die Erkenntnis Gottes aus geistlicher Sklaverei"
  },
  
  levels: {
    14: {
      name: "Mose aus dem Wasser gerettet",
      challenge: "Und die Frau wurde schwanger und gebar einen Sohn. Als sie sah, dass er schön war...",
      easy: {
        question: "Worin versteckte Moses Mutter ihren Sohn?",
        options: ["Eine Höhle", "Ein Binsenkörbchen", "Ein Korb", "Ein Haus"],
        hint: "Dieser Behälter schwamm auf dem Nil",
        funFact: "🏺 Das Binsenkörbchen war mit Pech abgedichtet, um wasserdicht zu sein!"
      },
      medium: {
        question: "Wer fand Mose im Schilf?",
        options: [
          "Die Tochter des Pharao",
          "Eine ägyptische Magd",
          "Seine Schwester Mirjam",
          "Ein ägyptischer Priester"
        ],
        hint: "Ein Mitglied der ägyptischen Königsfamilie",
        funFact: "👑 Ironischerweise rettet die Familie des Pharao denjenigen, der ihn herausfordern wird!"
      },
      hard: {
        question: "Wie nutzt die göttliche Vorsehung sogar unsere Feinde?",
        options: [
          "Indem sie sie bekehrt",
          "Indem sie die Umstände orchestriert, um ihre Absichten zu erfüllen",
          "Indem sie sie bestraft",
          "Indem sie sie ignoriert"
        ],
        hint: "Es geht darum, Gottes Hand in den Ereignissen zu sehen",
        funFact: "✨ Mose wuchs im Palast dessen auf, der sein Volk unterdrückte!"
      }
    },
    
    15: {
      name: "Der brennende Dornbusch",
      challenge: "Der Engel des HERRN erschien ihm in einer Feuerflamme...",
      easy: {
        question: "Was musste Mose vor dem brennenden Dornbusch ausziehen?",
        options: ["Seinen Schmuck", "Seine Sandalen", "Seinen Mantel", "Seinen Turban"],
        hint: "Was man an den Füßen trägt",
        funFact: "👡 Sich die Schuhe auszuziehen drückt Respekt auf heiligem Boden aus!"
      },
      medium: {
        question: "Welchen Namen offenbart Gott Mose?",
        options: [
          "Der HERR",
          "ICH BIN, DER ICH BIN",
          "Der Allmächtige",
          "Der Schöpfer"
        ],
        hint: "Ein Name, der absolute Existenz ausdrückt",
        funFact: "🔥 JHWH (Ich bin) offenbart das ewige Wesen Gottes!"
      },
      hard: {
        question: "Was lehrt uns der brennende Dornbusch, der nicht verbrennt?",
        options: [
          "Magie existiert",
          "Gott transzendiert die Naturgesetze",
          "Feuer ist heilig",
          "Pflanzen sind magisch"
        ],
        hint: "Es geht um die göttliche Natur, die unser Verständnis übersteigt",
        funFact: "🌿 Der Dornbusch symbolisiert, dass die göttliche Gegenwart heiligt, ohne zu zerstören!"
      }
    },

    16: {
      name: "Die Zehn Plagen Ägyptens",
      challenge: "Aber der Pharao verstockte sein Herz und hörte nicht auf sie...",
      easy: {
        question: "Was war die erste Plage Ägyptens?",
        options: ["Die Frösche", "Wasser in Blut verwandelt", "Die Fliegen", "Die Läuse"],
        hint: "Sie betraf den Nil, die Lebensquelle Ägyptens",
        funFact: "🩸 Der Nil wurde als Gott verehrt, und Gott zeigte seine Überlegenheit!"
      },
      medium: {
        question: "Was war die letzte und schrecklichste der Plagen?",
        options: [
          "Der Hagel",
          "Die Finsternis",
          "Der Tod der Erstgeborenen",
          "Die Heuschrecken"
        ],
        hint: "Diese Plage traf die Familien direkt",
        funFact: "😢 Diese Plage brach endlich den Stolz des Pharao und befreite Israel!"
      },
      hard: {
        question: "Warum verhärtet Gott das Herz des Pharao?",
        options: [
          "Um ihn zu bestrafen",
          "Um seine Herrlichkeit und Macht zu offenbaren",
          "Aus Bosheit",
          "Um das Leiden zu verlängern"
        ],
        hint: "Es geht darum zu zeigen, wer der wahre Gott ist",
        funFact: "⚡ Die Plagen beweisen, dass JHWH mächtiger ist als alle ägyptischen Götter!"
      }
    },

    17: {
      name: "Das Passah",
      challenge: "Nehmt euch ein Lamm... und streicht sein Blut an die Pfosten...",
      easy: {
        question: "Wo sollten die Israeliten das Blut des Lammes anbringen?",
        options: [
          "An ihrer Kleidung",
          "An die Türpfosten und Überschwellen",
          "An ihre Stirn",
          "In Kelche"
        ],
        hint: "Am Eingang ihrer Häuser",
        funFact: "🩸 Das Blut an der Tür war das Zeichen des göttlichen Schutzes!"
      },
      medium: {
        question: "Wie sollten sie das Passahlamm essen?",
        options: [
          "Bequem sitzend",
          "Nur in der Familie",
          "Ihre Lenden gegürtet, Schuhe an den Füßen, Stab in der Hand",
          "In Stille"
        ],
        hint: "Bereit zur Abreise",
        funFact: "🚶 Sie mussten bereit sein, schnell in die Freiheit aufzubrechen!"
      },
      hard: {
        question: "Wie ist das Passahlamm ein Vorbild auf Christus?",
        options: [
          "Durch seine weiße Farbe",
          "Durch sein stellvertretendes Opfer, das vor dem Tod rettet",
          "Durch seine Sanftmut",
          "Durch sein Alter"
        ],
        hint: "Es geht um das Opfer, das vor der Verdammnis bewahrt",
        funFact: "🐑 Jesus wird 'das Lamm Gottes, das die Sünde der Welt hinwegnimmt' genannt!"
      }
    },

    18: {
      name: "Die Durchquerung des Roten Meeres",
      challenge: "Und Mose streckte seine Hand über das Meer aus...",
      easy: {
        question: "Wie durchquerten die Israeliten das Meer?",
        options: [
          "Mit dem Boot",
          "Schwimmend",
          "Trockenen Fußes",
          "Auf einem Floß"
        ],
        hint: "Der Meeresboden war begehbar",
        funFact: "🌊 Gott verwandelte ein Hindernis in einen Weg der Befreiung!"
      },
      medium: {
        question: "Was geschah mit den Ägyptern, die verfolgten?",
        options: [
          "Sie kehrten um",
          "Sie wurden von den Wassern verschlungen",
          "Sie verirrten sich",
          "Sie schlossen sich Israel an"
        ],
        hint: "Die Wasser kamen über sie zurück",
        funFact: "⚔️ Die mächtigste Armee der Welt wurde in einem Augenblick vernichtet!"
      },
      hard: {
        question: "Was symbolisiert diese Durchquerung in unserem geistlichen Leben?",
        options: [
          "Die Flucht vor Problemen",
          "Der Übergang von der Sklaverei der Sünde zur Freiheit in Gott",
          "Die Überlegenheit Israels",
          "Die Zerstörung der Feinde"
        ],
        hint: "Es geht um eine geistliche Verwandlung",
        funFact: "🗽 Das Rote Meer steht für die Taufe: Tod dem Alten, neues Leben!"
      }
    },

    19: {
      name: "Das Manna in der Wüste",
      challenge: "Was ist das? Denn sie wussten nicht, was es war...",
      easy: {
        question: "Wie lange fiel das Manna?",
        options: ["10 Jahre", "20 Jahre", "40 Jahre", "50 Jahre"],
        hint: "Die gleiche Anzahl wie die Jahre in der Wüste",
        funFact: "🍞 40 Jahre lang ernährte Gott auf wundersame Weise 2 Millionen Menschen!"
      },
      medium: {
        question: "Was geschah, wenn man das Manna länger als einen Tag aufbewahrte?",
        options: [
          "Es wurde schmackhafter",
          "Es vermehrte sich",
          "Es verfaulte und stank",
          "Es verhärtete sich"
        ],
        hint: "Außer freitags für den Sabbat",
        funFact: "🪱 Gott lehrte damit die tägliche Abhängigkeit von Ihm!"
      },
      hard: {
        question: "Wie lehrt uns das Manna Vertrauen?",
        options: [
          "Durch Vorratshaltung für die Zukunft",
          "Durch das Vertrauen auf Gottes tägliche Versorgung",
          "Durch härtere Arbeit",
          "Durch gleichmäßiges Teilen"
        ],
        hint: "Es geht darum, Tag für Tag zu vertrauen",
        funFact: "🙏 'Unser tägliches Brot gib uns heute' kommt von dieser Erfahrung!"
      }
    },

    20: {
      name: "Das Wasser aus dem Felsen",
      challenge: "Du sollst den Felsen schlagen, und es wird Wasser herauskommen...",
      easy: {
        question: "Womit sollte Mose den Felsen schlagen?",
        options: ["Seiner Hand", "Seinem Stab", "Einem Stein", "Einem Hammer"],
        hint: "Das Instrument der Wunder Moses",
        funFact: "⚡ Der Stab Moses war das Instrument der göttlichen Macht!"
      },
      medium: {
        question: "Warum murrte das Volk gegen Mose?",
        options: [
          "Es gab kein Trinkwasser",
          "Das Essen fehlte",
          "Der Weg war zu lang",
          "Es war zu heiß"
        ],
        hint: "Ein lebenswichtiges Bedürfnis in der Wüste",
        funFact: "💧 Wasser ist wichtiger als Nahrung fürs Überleben!"
      },
      hard: {
        question: "Was stellt das Wasser aus dem Felsen geistlich dar?",
        options: [
          "Natürliche Ressourcen",
          "Das geistliche Leben, das aus Christus, dem Felsen, hervorquillt",
          "Der Lohn für Anstrengungen",
          "Göttliche Magie"
        ],
        hint: "Paulus sagt, dieser Fels war Christus",
        funFact: "🗿 Christus ist der geschlagene Fels, aus dem das ewige Leben entspringt!"
      }
    },

    21: {
      name: "Der Berg Sinai",
      challenge: "Der ganze Berg Sinai war in Rauch gehüllt, weil der HERR darauf herabgestiegen war...",
      easy: {
        question: "Wie viele Gebote gab Gott?",
        options: ["5", "7", "10", "12"],
        hint: "Eine runde und vollkommene Zahl",
        funFact: "📜 Die Zehn Gebote sind die moralische Grundlage der Menschheit!"
      },
      medium: {
        question: "Worauf wurden die Gebote geschrieben?",
        options: [
          "Papyrus",
          "Pergament",
          "Zwei Steintafeln",
          "Bronze"
        ],
        hint: "Ein dauerhaftes Material, geschrieben vom Finger Gottes",
        funFact: "✍️ Von Gott selbst geschrieben, um ihre ewige Bedeutung zu zeigen!"
      },
      hard: {
        question: "Was ist das Ziel der göttlichen Gebote?",
        options: [
          "Menschen zu bestrafen",
          "Gottes Heiligkeit zu offenbaren und zum Glück zu führen",
          "Komplexe Regeln zu schaffen",
          "Völker zu trennen"
        ],
        hint: "Es geht darum, den göttlichen Charakter und den Weg zum Guten zu offenbaren",
        funFact: "⚖️ Die Gebote offenbaren die Liebe: Liebe zu Gott und zum Nächsten!"
      }
    },

    22: {
      name: "Das goldene Kalb",
      challenge: "Mache uns einen Gott, der vor uns herzieht...",
      easy: {
        question: "Womit machte Aaron das goldene Kalb?",
        options: [
          "Goldmünzen",
          "Den goldenen Ohrringen des Volkes",
          "Kostbarem Schmuck",
          "Wüstengold"
        ],
        hint: "Persönlicher Schmuck, den das Volk gab",
        funFact: "👂 Das Volk gab seinen Schmuck, um sein eigenes Idol zu schaffen!"
      },
      medium: {
        question: "Was war Moses Reaktion, als er das Kalb sah?",
        options: [
          "Er weinte",
          "Er betete",
          "Er zerbrach die Gesetzestafeln",
          "Er wurde nur wütend"
        ],
        hint: "Eine symbolische Geste des gebrochenen Bundes",
        funFact: "💥 Das Zerbrechen der Tafeln symbolisierte, dass der Bund gebrochen war!"
      },
      hard: {
        question: "Warum ist Götzendienst geistlich so gefährlich?",
        options: [
          "Er ist teuer",
          "Er wendet das Herz vom wahren Gott zu Geschöpfen",
          "Er spaltet Familien",
          "Er ist verboten"
        ],
        hint: "Es geht darum, dem Geschöpf zu geben, was dem Schöpfer gehört",
        funFact: "💔 Götzendienst bricht die exklusive Beziehung mit dem lebendigen Gott!"
      }
    },

    23: {
      name: "Die Stiftshütte",
      challenge: "Sie sollen mir ein Heiligtum machen, damit ich unter ihnen wohne...",
      easy: {
        question: "Wie nannte man das heilige Zelt der Israeliten?",
        options: ["Der Tempel", "Die Stiftshütte", "Das Heiligtum", "Die Lade"],
        hint: "Der Name bedeutet 'Zelt der Begegnung'",
        funFact: "⛺ Die Stiftshütte war Gottes 'mobiles Haus' bei seinem Volk!"
      },
      medium: {
        question: "Was enthielt die Bundeslade?",
        options: [
          "Den Schmuck des Hohenpriesters",
          "Die Gesetzestafeln, das Manna, Aarons Stab",
          "Goldstücke",
          "Die Tora-Rollen"
        ],
        hint: "Drei Gegenstände, die den Bund mit Gott symbolisieren",
        funFact: "📦 Die Lade enthielt die 'Erinnerungen' an Gottes Treue!"
      },
      hard: {
        question: "Was symbolisiert die Stiftshütte in unserer Beziehung zu Gott?",
        options: [
          "Ein religiöses Gebäude",
          "Gottes Gegenwart, die unter und in uns wohnt",
          "Nur ein Opferplatz",
          "Ein nationales Symbol"
        ],
        hint: "Es geht um die zugängliche göttliche Gegenwart",
        funFact: "🏠 'Euer Leib ist der Tempel des Heiligen Geistes' laut Paulus!"
      }
    },

    24: {
      name: "Der Hohepriester Aaron",
      challenge: "Du sollst Aaron und seine Söhne weihen, damit sie meine Priester seien...",
      easy: {
        question: "Wer war der erste Hohepriester Israels?",
        options: ["Mose", "Aaron", "Josua", "Eleasar"],
        hint: "Der Bruder Moses",
        funFact: "👨‍⚕️ Aaron gründete die priesterliche Linie, die über 1000 Jahre dauerte!"
      },
      medium: {
        question: "Was trug der Hohepriester auf seiner Brust?",
        options: [
          "Ein goldenes Kreuz",
          "Das Brustschild mit den zwölf Edelsteinen",
          "Ein Medaillon",
          "Eine goldene Kette"
        ],
        hint: "Zwölf Steine, die die zwölf Stämme darstellen",
        funFact: "💎 Der Hohepriester trug symbolisch ganz Israel auf seinem Herzen!"
      },
      hard: {
        question: "Wie erfüllt Jesus die Rolle des Hohenpriesters?",
        options: [
          "Durch das Tragen heiliger Gewänder",
          "Durch das Opfern seines eigenen Blutes ein für alle Mal",
          "Durch den Dienst im Tempel",
          "Durch Abstammung von Aaron"
        ],
        hint: "Es geht um ein perfektes und endgültiges Opfer",
        funFact: "✝️ Jesus ist ewiger Hohepriester nach der Ordnung Melchisedeks!"
      }
    },

    25: {
      name: "Die Opfer",
      challenge: "Wenn jemand von euch dem HERRN ein Opfer darbringen will...",
      easy: {
        question: "Was war das tägliche Opfer in der Stiftshütte?",
        options: [
          "Das Friedensopfer",
          "Das Brandopfer am Morgen und Abend",
          "Das Sündopfer",
          "Das Speisopfer"
        ],
        hint: "Zweimal täglich, morgens und abends",
        funFact: "🔥 Das Feuer auf dem Altar durfte niemals erlöschen!"
      },
      medium: {
        question: "Was symbolisierte das Auflegen der Hände auf das Tier?",
        options: [
          "Segen",
          "Die Übertragung der Sünden auf das Opfer",
          "Zuneigung zum Tier",
          "Weihe"
        ],
        hint: "Eine Geste der Stellvertretung",
        funFact: "🤲 Das Tier starb anstelle des Sünders - Prinzip der Stellvertretung!"
      },
      hard: {
        question: "Wie sind diese Opfer ein Vorbild auf das Werk Christi?",
        options: [
          "Durch ihre Anzahl",
          "Durch die Stellvertretung: Der Unschuldige stirbt für den Schuldigen",
          "Durch ihre Kosten",
          "Durch ihre Schönheit"
        ],
        hint: "Es geht um das Prinzip des Unschuldigen, der den Platz des Schuldigen einnimmt",
        funFact: "🐑 'Er wurde verwundet für unsere Sünden, zerschlagen für unsere Schuld'!"
      }
    },

    26: {
      name: "An den Grenzen des Gelobten Landes",
      challenge: "Ich werde einen Engel vor dir hersenden und die Kanaaniter vertreiben...",
      easy: {
        question: "Wie viele Kundschafter wurden ausgesandt, um das Gelobte Land zu erkunden?",
        options: ["10", "12", "20", "40"],
        hint: "Einer pro Stamm Israels",
        funFact: "🕵️ Nur 2 der 12 Kundschafter gaben einen ermutigenden Bericht ab!"
      },
      medium: {
        question: "Welche Kundschafter ermutigten das Volk, das Land einzunehmen?",
        options: [
          "Aaron und Mose",
          "Josua und Kaleb",
          "Gad und Asser",
          "Ruben und Simeon"
        ],
        hint: "Zwei Männer des Glaubens, die Gottes Verheißungen sahen",
        funFact: "🦁 Josua und Kaleb waren die einzigen ihrer Generation, die Kanaan betraten!"
      },
      hard: {
        question: "Warum irrte Israel 40 Jahre in der Wüste umher?",
        options: [
          "Zur Bestrafung",
          "Wegen ihres Unglaubens an die göttlichen Verheißungen",
          "Um sie für den Kampf zu trainieren",
          "Um den richtigen Weg zu finden"
        ],
        hint: "Es geht um mangelndes Vertrauen in Gott",
        funFact: "🏜️ Eine ganze Generation musste wegen des Unglaubens sterben!"
      }
    }
  }
};

export default chapter2Translations;
